import type {
    MembershipBillingFrequency,
    SubscriptionProductId,
} from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface ChangeTestUserSubscriptionResponseDto {
    id: string;
    status: string;
}

export interface ChangeTestUserSubscriptionBody {
    email: string;
    membershipType: SubscriptionProductId;
    billingFrequency: MembershipBillingFrequency;
}

const useChangeTestUserSubscription = requestBuilder.mutation<
    ChangeTestUserSubscriptionResponseDto,
    ChangeTestUserSubscriptionBody
>({
    endpoint: '/api/dev/change-test-user-subscription',
    method: 'POST',
});

export default useChangeTestUserSubscription;
